import { escapeRegExp } from 'lodash';

export const escapedRegexString = str => new RegExp(escapeRegExp(str), 'i').toString();
